module.exports = __webpack_public_path__ + "img/kix-country.1fdd64d2.png";